var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { Timeouts } from './framework/Timeouts';
import { TransportError } from './framework/Transport';
export class Aneuvideo {
    constructor(socket, state, log, framework) {
        this.socket = socket;
        this.state = state;
        this.framework = framework;
        // other class properties and constructor
        this.timeouts = new Timeouts();
        this.busyTimeout = this.timeouts.create();
        // Different models have different video switching API commands.
        this.models = {
            '-OJZQ9TN2pSFgcXm7I-_': { name: 'ANI-4-8K60-S', api: '8x8 8K60' },
            '-OJZQ9TOnx8FrpEAUmJe': { name: 'ANI-8-4K60-S', api: '8x8 4K60' },
            '-OJZQ9TOnx8FrpEAUmJf': { name: 'ANI-8-8K60-S', api: '8x8 8K60' },
            '-OJZQ9TPb8WyVMteehi-': { name: 'ANI-16-4K60-S', api: '16x16 4K60' },
        };
        this.defaultModelNumber = '16x16';
        this.model = this.models[this.defaultModelNumber];
        // controls
        this.busy = {
            get: (tags) => __awaiter(this, void 0, void 0, function* () {
                return this.state.busy.value;
            }),
        };
        this.firmwareVersion = {
            get: (tags) => __awaiter(this, void 0, void 0, function* () {
                const match = yield this.socket.send(`r fw version!`, /([\d\.]+)/i, tags);
                return match[1] ? match[1] : 'unknown';
            }),
            powerOffRestrictions: ['get'],
        };
        this.power = {
            get: (tags) => __awaiter(this, void 0, void 0, function* () {
                const match = yield this.socket.send(`r power!`, /power\s+(on|off|\d)/i, tags);
                return match[1].toLowerCase() === 'on' || match[1] === '1';
            }),
            set: (power, tags) => __awaiter(this, void 0, void 0, function* () {
                if (this.model.api === '8x8 4K60') {
                    const match = yield this.socket.send(`> PWR ${power ? 'T' : 'F'}`, /<\s*PWR:\s+(T|F)/i, tags, { sendTimeoutMs: 6000 } // ack upon power on takes longer
                    );
                    this.state.busy.update(true);
                    this.busyTimeout.set(() => this.state.busy.update(false), power ? 20000 : 1000);
                    // Takes about 20 seconds after power up before it accepts commands again.
                    this.framework.suspend(power ? 20000 : 1000);
                    return match[1].toLowerCase() === 't';
                }
                else {
                    const match = yield this.socket.send(`s power ${power ? '1' : '0'}!`, /power\s+(on|off|\d)/i, tags, { sendTimeoutMs: 6000 } // ack upon power on takes longer
                    );
                    this.state.busy.update(true);
                    this.busyTimeout.set(() => this.state.busy.update(false), power ? 20000 : 1000);
                    // Takes about 20 seconds after power up before it accepts commands again.
                    this.framework.suspend(power ? 20000 : 1000);
                    return match[1].toLowerCase() === 'on' || match[1] === '1';
                }
                return this.state.power.value;
            }),
        };
        this.videoMatrixRoutes = {
            get: (key, tags) => __awaiter(this, void 0, void 0, function* () {
                if (this.model.api === '16x16 4K60') {
                    const match = yield this.socket.send(`r av out ${key}!`, /(?:input)?\s*(\d+)\s*->\s*(?:output)?\s*(\d+)/i, tags);
                    return parseInt(match[1], 10).toString(); // remove leading 0's
                }
                else if (this.model.api === '8x8 8K60') {
                    const match = yield this.socket.send(`r output ${key} in source!`, /(?:output)?\s*(\d+)\s*->\s*(?:input)?\s*(\d+)/i, tags);
                    return parseInt(match[2], 10).toString(); // remove leading 0's
                }
                else if (this.model.api === '8x8 4K60') {
                    // TODO: determine if there is a query command
                    return this.state.videoMatrixRoutes.values[key];
                }
                return this.state.videoMatrixRoutes.values[key];
            }),
            set: (key, value, tags) => __awaiter(this, void 0, void 0, function* () {
                if (this.model.api === '16x16 4K60') {
                    const match = yield this.socket.send(`s in ${value} av out ${key}!`, /(?:input)?\s*(\d+)\s*->\s*(?:output)?\s*(\d+)/i, tags);
                    return parseInt(match[1], 10).toString(); // remove any leading 0's
                    //
                }
                else if (this.model.api === '8x8 8K60') {
                    const match = yield this.socket.send(`s output ${key} in source ${value}!`, /(?:output)?\s*(\d+)\s*->\s*(?:input)?\s*(\d+)/i, tags);
                    return parseInt(match[2], 10).toString(); // remove any leading 0's
                    //
                }
                else if (this.model.api === '8x8 4K60') {
                    const match = yield this.socket.send(`> SWT ${key}:${value}`, /<\s*SWT\s*(\d+)\s*:\s*(\d+)/i, tags);
                    return parseInt(match[2], 10).toString(); // remove any leading 0's
                }
                return this.state.videoMatrixRoutes.values[key];
            }),
            asyncHandlers: [
                {
                    regExp: /input\s*(\d+)\s*->\s*output\s*(\d+)/i,
                    callback: (match) => {
                        const value = parseInt(match[1], 10).toString(); // remove any leading 0's
                        const key = parseInt(match[2], 10).toString();
                        this.state.videoMatrixRoutes.update(key, value);
                    },
                },
                {
                    regExp: /output\s*(\d+)\s*->\s*input\s*(\d+)/i,
                    callback: (match) => {
                        const value = parseInt(match[2], 10).toString();
                        const key = parseInt(match[1], 10).toString();
                        this.state.videoMatrixRoutes.update(key, value);
                    },
                },
            ],
            powerOffRestrictions: ['get', 'set'],
        };
        // polling
        this.polls = [
            {
                intervalMs: 4000,
                controls: ['power', 'videoMatrixRoutes'],
            },
        ];
    }
    // phase callbacks
    onBeforeConfigure(config) {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function* () {
            const modelNumber = (_a = config === null || config === void 0 ? void 0 : config.modelNumber) !== null && _a !== void 0 ? _a : this.defaultModelNumber;
            this.model = (_b = this.models[modelNumber]) !== null && _b !== void 0 ? _b : this.models[this.defaultModelNumber];
        });
    }
    onConfigure(config) {
        return __awaiter(this, void 0, void 0, function* () {
            this.timeouts.clearAll();
        });
    }
    onDisconnect() {
        return __awaiter(this, void 0, void 0, function* () {
            this.timeouts.clearAll();
        });
    }
    onInitialize(credentials) {
        return __awaiter(this, void 0, void 0, function* () {
            // Try power query which works for some models.
            try {
                yield this.socket.send('r power!', /power\s*(on|off)/i, ['initialize']);
                return 'connected';
            }
            catch (error) {
                if (!(error instanceof TransportError && error.code === 'sendTimeout')) {
                    throw error;
                }
            }
            // Try sending a status query for other models.
            try {
                yield this.socket.send('> STA', /SWT:/i, ['initialize']);
                return 'connected';
            }
            catch (error) {
                if (!(error instanceof TransportError && error.code === 'sendTimeout')) {
                    throw error;
                }
            }
            return 'verifyFailed';
        });
    }
}
// static properties
Aneuvideo.driverType = 'socketDriver';
Aneuvideo.key = '-OJsDWjuOTyurwypTw6T';
Aneuvideo.baseSocketOptions = {
    commandExtractor: {
        terminators: ['\r', '\n'],
    },
    sendTerminator: '\r',
};
Aneuvideo.socketOptions = [
    Object.assign(Object.assign({}, Aneuvideo.baseSocketOptions), { port: 8000 }),
    Object.assign(Object.assign({}, Aneuvideo.baseSocketOptions), { port: 23 }),
    Object.assign(Object.assign({}, Aneuvideo.baseSocketOptions), { port: 4999 }),
];
